/**
 * Close all the expanded panels according their layers by clicking on it
 * @param css rule for targeting expanded elements
 */

export const closeLayer = (cssRule: string): any => {

    const targets: any = document.querySelectorAll(cssRule);

    for (const elt of targets) {
        elt.click();
    }
};
